module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Note#uglDW5TMEBazcF9VZGxHvYD"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ack#u49OgEGmahNfkAXxyKZ7ha3"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#uvJtDlmVXGUakh45y2aiSTE"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#u4zoQDQRnQ8rS44kuKdA6L9"
    }
  }, [_vm._v("1: The Scoop")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_02#uG9PqKWlCtTLGKCErYq38IF"
    }
  }, [_vm._v("2: Michigan’s Crown Jewel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_03#uaj5dR4JgWMgxKcnBiKmW8F"
    }
  }, [_vm._v("3: Frances")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_04#uWEexKqwZbgzupbK92g5MC9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Missing")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#ukDdIuBhGQMUNj8jtsUmjcD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: The Search Begins")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#uFbpXEA6Xx6Zo8pAnXgPYI5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Paul Strantz")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#u3pkAOs4wkbRTGSmY3dxOQ8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: First Clues")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#u878ozK4WDajo7HZwcX7rk3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Grim Paradise")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_09#uSRYHn5PYQturVtplYwEFeC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Postmortem")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_10#u9RtFSxPWlcSX9RhaEpYrV4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: The Hunt")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_11#uzjHsM335FVxdcWqHqFpDQG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: Moral Re-armament")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_12#umcMd4Qx9oOFrw8IIqSEbn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: Expanding The Search")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_13#uEqy6UIdegCa2ZcpHjURyG8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: Hurried Getaway")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_14#u6xbzevHr8QUsSF6sgNWfw2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: Harold Asp")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_15#u4Jg4pKzRlrFRQEwaTDCs9H",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: The Billfold")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_16#upuDCzmQt6n6Uu8FGlRW2gF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photos")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_17#uTgQtUtjmKTK4VvL5FzOGmG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: Trace Evidence")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_18#uElwe7KjLsoB4kZMejVtgF9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17: Mrs. DeCourval")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_19#ub3Cu8rT8RnTZpBEam7SGuA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18: New Tips")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_20#uCItdcj7gtiUhmgNobBXGFE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19: Stalled")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_21#uf3fwqMvGiDMvnTwgg2bEvA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20: Starved Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_22#u39SmgR763zgESTkJcMbIO6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21: Tiny")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_23#ukLuTiD4oGapfSZNcQNSLv4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22: Murder in Minnesota")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_24#utKSC2e3TYallXIZXlvbQK9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23: The Jungfrau")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_25#ubbI937RXctGPMEx3nymKg8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24: Fisher")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_26#uVXnkXsFXjrtiDp9kBnF8C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25: The Thompson Murder")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_27#uSxOOQF5lJabhqZT2XkP4LB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26: Paul Strantz Returns")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_28#uuiv7IaVVLECvGIqjwjZlD6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27: Long-Term Storage")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_29#uRHYM3kiXHlUqW8fcgeldH8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28: Profiles")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_30#uMm9eHy4jfuZ7hZWExclbDC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29: Lost")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_31#uz4bV4UuAbvWFBOOqJX8ca3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30: A New Person of Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword#ut4qqTXDKy7yBYcl5q2oC58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Biblio#uiqMzXnxDxAoZYnTGLSMPi3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea93f88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 75
// module chunks = 0